import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SystemModel, Institution, SalesRep, Chain, SalesEntityModel, AlliancePartner, Association, SalesEntityBoardingHierarchyNew } from 'app/shared/models/EvoSalesPortalModel';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'se-boarding-modal',
    styleUrls: ['./se-boarding-content.component.scss'],
    templateUrl: 'se-boarding-content.component.html',
})
export class SalesEntityBoardingSelectorModalComponent {
    bindingContext: BindingContext = new BindingContext();
    public salesEntityTreeModel: SalesEntityModelList = new SalesEntityModelList();
    @Input() salesEntityID: number;
    savingHierarchy:boolean = false;
    public isDefault: boolean = false;

    hasChildren: boolean;
    Systems: Array<SystemModel>;
    _selected_System: number;
    getting_Systems = false;

    Institutions: Array<Institution>;
    _selected_Institution: number;
    public getting_Institutions = false;

    Associations: Array<Association>;
    _selected_Association: number;
    public getting_Associations = false;

    SalesReps: Array<SalesRep>;
    _selected_SalesRep: number;
    public getting_SalesReps = false;

    Chains: Array<Chain>;
    _selected_Chain: number;
    public getting_Chains = false;

    public get selectedSystem(): number {
        return this._selected_System;
    }
    public set selectedSystem(input: number) {
        if (this._selected_System !== input) {
            this._selected_System = input;
            if (this._selected_System) {
                this.getInstitutions(this._selected_System);
            }
        }
    }

    public get selectedInstitution(): number {
        return this._selected_Institution;
    }
    public set selectedInstitution(input: number) {
        this._selected_Institution = input;
    }

    public get selectedAssociation(): number {
        return this._selected_Association;
    }
    public set selectedAssociation(input: number) {
        this._selected_Association = input;
    }

    public get selectedSalesRep(): number {
        return this._selected_SalesRep;
    }
    public set selectedSalesRep(input: number) {
        this._selected_SalesRep = input;
    }

    public get selectedChain(): number {
        return this._selected_Chain;
    }
    public set selectedChain(input: number) {
        this._selected_Chain = input;
    }

    constructor(public activeModal: NgbActiveModal,
        private seSvc: SalesEntityService) {
        this.bindingContext.isBusy = false;
        this.getSystems();
    }

    ngOnInit() {

    }

    public getSystems() {
        if (!this.getting_Systems) {
            this.bindingContext.beginGet();
            this.getting_Systems = true;
            const promise = this.seSvc.getSystems().toPromise();
            promise
                .then((systems: Array<SystemModel>) => {
                    this.Systems = systems;
                    this.getting_Systems = false;
                    this.bindingContext.endGet(true);
                })
                .catch((response: HttpErrorResponse) => {
                    this.bindingContext.setError(response);
                    this.getting_Systems = false;
                });
        }
    }

    public getInstitutions(sid: number) {
        if (!this.getting_Institutions) {
            this.bindingContext.beginGet();
            this.getting_Institutions = true;
            this.seSvc
                .getInstitutions(sid)
                .toPromise()
                .then((payload: Array<Institution>) => {
                    this.Institutions = payload;
                    this.getting_Institutions = false;
                    this.bindingContext.endGet(true);
                })
                .catch((response: HttpErrorResponse) => {
                    this.bindingContext.setError(response);
                    this.getting_Institutions = false;
                });
        }
    }

    public getAssociations(sid: number, iid: number) {
        if (!this.getting_Associations) {
            this.bindingContext.beginGet();
            this.getting_Associations = true;
            this.seSvc
                .getAssociations(sid, iid)
                .toPromise()
                .then((payload: Array<Association>) => {
                    this.Associations = payload;
                    this.getting_Associations = false;
                    this.bindingContext.endGet(true);
                })
                .catch((response: HttpErrorResponse) => {
                    this.bindingContext.setError(response);
                    this.getting_Associations = false;
                });
        }
    }

    public getSalesReps(sid: number, iid: number, aid: number) {
        if (!this.getting_SalesReps) {
            this.bindingContext.beginGet();
            this.getting_SalesReps = true;
            this.seSvc
                .getSalesReps(sid, iid, aid)
                .toPromise()
                .then((payload: Array<SalesRep>) => {
                    this.SalesReps = payload;
                    this.getting_SalesReps = false;
                    this.bindingContext.endGet(true);
                })
                .catch((response: HttpErrorResponse) => {
                    this.bindingContext.setError(response);
                    this.getting_SalesReps = false;
                });
        }
    }

    public getChains(sid: number, iid: number, aid: number, srid: number) {
        if (!this.getting_Chains) {
            this.bindingContext.beginGet();
            this.getting_Chains = true;
            this.seSvc
                .getChains(sid, iid, aid, srid)
                .toPromise()
                .then((payload: Array<Chain>) => {
                    this.Chains = payload;
                    this.getting_Chains = false;
                    this.bindingContext.endGet(true);
                })
                .catch((response: HttpErrorResponse) => {
                    console.error(response);
                    this.bindingContext.setError(response);
                    this.getting_Chains = false;
                });
        }
    }

    /**
     * Stores the selection of the system
     * @param system The system model that has been selected
     */
    onSystemSelected(system: number) {
        console.log(system);
        this.selectedSystem = system;
        this.selectedInstitution = undefined;
        this.selectedAssociation = undefined;
        this.selectedSalesRep = undefined;
        this.selectedChain = undefined;
        this.getInstitutions(this.selectedSystem);
    }
    /**
     * Saves the selection of the institution
     * @param institution The instution model that has been selected
     */
    onInstitutionSelected(institution: number) {
        console.log(institution);
        this.selectedInstitution = institution;
        this.selectedAssociation = undefined;
        this.selectedSalesRep = undefined;
        this.selectedChain = undefined;
        this.getAssociations(this.selectedSystem, this.selectedInstitution);
    }
    /**
     * Saves the selection of the association
     * @param association The association model that has been selected
     */
    onAssociationSelected(association: number) {
        console.log(association);
        this.selectedAssociation = association;
        this.selectedSalesRep = undefined;
        this.selectedChain = undefined;
        this.getSalesReps(this.selectedSystem, this.selectedInstitution, this.selectedAssociation);
    }
    /**
     * Saves the selection of the sales rep
     * @param salesRep The sales rep model that has been selected
     */
    onSalesRepSelected(salesRep: number) {
        console.log(salesRep);
        this.selectedSalesRep = salesRep;
        this.selectedChain = undefined;
        console.log("getting chains");
        this.getChains(this.selectedSystem, this.selectedInstitution, this.selectedAssociation, this.selectedSalesRep);
    }
    /**
     * Saves the selection of the chain
     * @param chain The chain model that has been selected
     */
    onChainSelected(chain: number) {
        this.selectedChain = chain;
    }
    /**
     * Finalizes the addition of the boarding hierarchy
     * Saves, and closes the modal
     * @returns Returns the success value to the component opening this modal
     */
    public AddBoardingHierarchy() {
        let obj: SalesEntityBoardingHierarchyNew = new SalesEntityBoardingHierarchyNew();
        if (this.selectedSystem) { obj.SystemID = this.selectedSystem; }
        if (this.selectedAssociation) { obj.AssociationID = this.selectedAssociation; }
        if (this.selectedInstitution) { obj.InstitutionID = this.selectedInstitution; }
        if (this.selectedSalesRep) { obj.SalesRepID = this.selectedSalesRep; }
        if (this.selectedChain) { obj.ChainID = this.selectedChain; }
        if (this.salesEntityID) { obj.SalesEntityID = this.salesEntityID; }
        if (this.isDefault) { obj.Default = this.isDefault; } else { obj.Default = false; }
        //Make the call
        this.savingHierarchy = true;
        this.seSvc.AddBoardingHierarchy(obj).toPromise().then(resp => {
            //Report success or failure
            let success = true;
            this.savingHierarchy = false;
            //Close the modal
            this.activeModal.close(success);
        }).catch(resp => {
            //500 I guess?
            this.savingHierarchy = false;
            alert('There was a problem adding new hierarchy.');
        });

    }

}
